/**
 * Hand-authored design-system icon (not sourced from @central-icons-react).
 * Kept in the generated icons folder using the `.gen` suffix so the barrel's
 * import convention and the generator's index rebuild both pick it up.
 *
 * A filled status marker for success surfaces (Banner, Toast). The circle fills
 * with `currentColor`; the checkmark glyph is a separate solid white path so it
 * stays white on any background or theme (the generated `IconCircleCheck`
 * filled variant knocks the glyph out instead, which shows the dark surface in
 * dark mode). Part of the status-marker set alongside `IconErrorDiamond`.
 */

import { memo } from 'react'

import { cn } from '#lib/cn'

import { type IconProps, IconSize, iconSizeValues } from '../types'

export const IconSuccessCircle = memo(function IconSuccessCircle({
  size = IconSize.Medium,
  title,
  className,
  ref,
  ...props
}: IconProps) {
  return (
    <svg
      width={`${iconSizeValues[size]}px`}
      height={`${iconSizeValues[size]}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!title}
      aria-label={title}
      className={cn('shrink-0', className)}
      ref={ref}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
        fill="currentColor"
      />
      <path
        d="M15.5805 9.97493C15.8428 9.65434 15.7955 9.18183 15.4749 8.91953C15.1543 8.65724 14.6818 8.70449 14.4195 9.02507L10.4443 13.8837L9.03033 12.4697C8.73744 12.1768 8.26256 12.1768 7.96967 12.4697C7.67678 12.7626 7.67678 13.2374 7.96967 13.5303L9.96967 15.5303C10.1195 15.6802 10.3257 15.7596 10.5374 15.7491C10.749 15.7385 10.9463 15.6389 11.0805 15.4749L15.5805 9.97493Z"
        fill="white"
      />
    </svg>
  )
})
